import { useAtomValue } from 'jotai';
import { useCallback, useMemo } from 'react';
import { currencyExchangeRateRTAtom } from '../../state';
import { Store } from '../../state/store';
import { CurrencyCross } from '../../types';

export const useCurrencyExchangeRate = () => {
  const currenciesExchangeRate = useAtomValue(currencyExchangeRateRTAtom);

  const getCurrenciesExchangeRateAsMap = useCallback((): Map<CurrencyCross, number> => {
    return new Map(
      Object.entries(currenciesExchangeRate)
        .map(([key, value]) => (value.isLoaded ? [key as CurrencyCross, value.rateInHuf] : [null, null]))
        .filter(v => v[0] !== null) as Array<[CurrencyCross, number]>,
    );
  }, [currenciesExchangeRate]);

  const getCurrenciesExchangeRateAsMapFromStore = useCallback((store: Store): Map<CurrencyCross, number> => {
    return new Map(
      Object.entries(store.get(currencyExchangeRateRTAtom))
        .map(([key, value]) => (value.isLoaded ? [key as CurrencyCross, value.rateInHuf] : [null, null]))
        .filter(v => v[0] !== null) as Array<[CurrencyCross, number]>,
    );
  }, []);

  return useMemo(
    () => ({
      currenciesExchangeRate,
      getCurrenciesExchangeRateAsMap,
      getCurrenciesExchangeRateAsMapFromStore,
    }),
    [currenciesExchangeRate, getCurrenciesExchangeRateAsMap, getCurrenciesExchangeRateAsMapFromStore],
  );
};
